function search() {
  return {
    cachedResults: {},
    loading: false,
    hasSearched: false,
    searchTerm: "",
    abortController: null,

    init() {
      this.abortController = new AbortController();
      document.addEventListener("keydown", function (e) {
        if (
          document.activeElement ===
            document.querySelector(".carousel-class") &&
          e.key === "Enter"
        ) {
          e.preventDefault();
          // Perform carousel action
        }
      });
    },

    onChange() {
      const newSearchTerm = this.getQuery();
      this.getSearchResults(newSearchTerm);
    },

    submit() {
      this.$refs.searchInput.closest("form").submit();
    },

    onKeyup(event) {
      event.preventDefault();

      switch (event.code) {
        case "ArrowUp":
          break;
        case "ArrowDown":
          break;
        case "Enter":
          break;
        case "Escape":
          this.$dispatch("toggle-search");
          break;
        default:
          const newSearchTerm = this.getQuery();
          this.getSearchResults(newSearchTerm);
          break;
      }
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },

    getQuery() {
      return this.searchTerm.trim();
    },

    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      this.loading = true;

      fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          searchTerm
        )}&section_id=predictive-search`,
        {
          signal: this.abortController.signal,
        }
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
          // Save bandwidth keeping the cache in all instances synced

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          throw error;
        });
    },

    renderSearchResults(resultsMarkup) {
      this.hasSearched = true;

      const predictiveSearchResults = document.querySelector(".search-result");
      predictiveSearchResults.innerHTML = resultsMarkup;
    },
  };
}

export default search;
